import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, TextArea, Grid, Checkbox, Message, Icon } from 'semantic-ui-react'
import TextEditor from '../../../../common/TextEditor';
import LoadingComponent from '../../../../common/LoadingComponent'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

// changes made for KLM-8917 KLM-8921
// Update made for KLM-8931
class AddSystemNotificationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(new Date().setHours(23, 59, 59, 999)),
      AddSystemNotificationError: null,
      title:'',
      description: '',
      expDate: '',
      // formcyButtonDisabled: false,
      // dateSelect: false
    }

    this.handleExpDate = this.handleExpDate.bind(this);
    this.onSubmitSystemNotification = this.onSubmitSystemNotification.bind(this);
    this.updateText = this.updateText.bind(this)
    // this.handleDate = this.handleDate.bind(this)
  }

  handleExpDate(date) {
    this.setState({
      startDate: date
    })
  }

  // handleDate() {
  //   this.setState({
  //     dateSelect: true
  //   })
  // }

  // buttonDisabled = (e, set) => {
  //   this.setState({ formcyButtonDisabled: set });
  // }

  async onSubmitSystemNotification(formData) {
    try {
      let nodeToAdd = {
        title: this.state.title,
        description: this.state.description,
        expDate: this.state.startDate,
        // accountId: this.props.accountId,
        // organizationId: this.props.organizationId,
      }
      // console.log(nodeToAdd);
      if (this.props.routeParams) {
        nodeToAdd.routeParams = this.props.routeParams
      }
      await dispatch.systemNotification.createSystemNotification(nodeToAdd);
      this.setState({ AddSystemNotificationError: null })
      this.props.closeModal();
    }
    catch (err) {
      throw err
      this.setState({ AddSystemNotificationError: err })
    }

  }

  updateText(data, name ) {
    if (name === "Title") {
      this.setState({ title: data })
    } else if (name === "Description") {
      this.setState({ description: data })
    } else if (name === "Expiry Date") {
      this.setState({ expDate: data })
    }
  }

  render() {

    let loading = <LoadingComponent active={this.props.loading} message="Adding..." />
    let titleLimitMsg = this.state.title.length > 25 ? <p className="clr-red">Max Limit is of 25 characters.</p> : <p>Remaining {25-this.state.title.length} / 25</p>
    let desLimitMsg = this.state.description.length > 100 ? <p className="clr-red">Max Limit is of 100 characters.</p> : <p>Remaining {100-this.state.description.length} / 100</p>
    let errorMsg = this.state.AddSystemNotificationError ?
      <span className='clr-red'>
        {this.state.AddSystemNotificationError.message}
      </span>
      : null

    return (
      <Modal
        open={this.props.isAddSystemNotificationModalOpen}
        onClose={this.props.closeModal}
        size='tiny'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
      >

        {loading}
        <Form noValidate
          className="formcyForm"
          ref={ref => this.form = ref}
          id="AddSystemNotificationForm"
          onValidSubmit={(event) => { this.onSubmitSystemNotification(event) }}
          // onValid={(e) => {
          //   if(this.state.title.length <=25 && this.state.description.length <=100) {
          //     this.buttonDisabled(e, true)
          //   }
          // }}
          // onInvalid={(e) => {
          //   if(this.state.title.length > 25) {
          //     this.buttonDisabled(e, false)
          //   }
          //   if(this.state.description.length > 100) {
          //     this.buttonDisabled(e, false)
          //   }
          // }}
        >
          <Modal.Content style={{ padding: "20px 20px 0 20px" }}>
          <div className="ui header">Add Notification</div>
            
            <TextEditor
              name="Title"
              text={this.state.title}
              type="text"
              onChangeText={this.updateText}
              autoFocus={true}
            />
            {titleLimitMsg}
            {errorMsg}

            {/* <Form.TextArea
                required
                name="Description"
                label="Description"
                id=""
                type="textarea"
                value={this.state.description}
                onChangeText={this.updateText}
            /> */}

            <TextEditor
              name="Description"
              text={this.state.description}
              type="text"
              onChangeText={this.updateText}
            />
            {desLimitMsg}
            {errorMsg}

            <label style={{ display: 'block', marginBottom: '5px'}} className="ui form" for="Expiry Date">Expiry Date & Time<span style={{ color: '#ff0000'}}> *</span></label>
            <DatePicker
              selected={ this.state.startDate }
              onChange={ this.handleExpDate }
              minDate={new Date(new Date().setHours(23, 59, 59, 999))}
              name="Expiry Date"
              dateFormat="MM/dd/yyyy"
              className="ui input timelineCalendarIcon"
              placeholder={'Please select a date'} 
            />
            {/* <Icon onClick={this.handleDate} name='calendar alternate outline exp-cal' /> */}
            {errorMsg}
            {/* {blankMessage} */}
            {/* <TextEditor
              name="Expiry Date"
              text={this.state.expDate}
              type="text"
              onChangeText={this.updateText}
              autoFocus={true}
            /> */}
          </Modal.Content>
          
          {/* below changes made for KLM-8934*/}
          <Modal.Actions className="actionInFormcy">
            <Button
              className="button-submit float-right"
              id='createbtn'
              type="submit"
              disabled={this.state.AddSystemNotificationError || (this.state.title.length > 25 || this.state.description.length > 100) || (this.state.title==="" || this.state.description==="") || (this.state.startDate === "" || this.state.startDate === null)}> Create
             </Button>
            <Button
              id='cancelBtn'
              className="button-cancel"
              onClick={this.props.closeModal}> Cancel
             </Button>
          </Modal.Actions>
            
        </Form>
      </Modal>
    )
  }
}

export default AddSystemNotificationModal